import { RedirectToAuthProps, redirectToAuth } from 'authorization-module'
import config from 'const/config'
import routes from 'const/routes'

const redirectToLwsIDP = (idToken: string, clientConsumerKey: string) => {
  const redirectUri = `${window.location.origin}${config.BASENAME}${routes.CALLBACK}`

  const authParams: RedirectToAuthProps = {
    baseURL: config.AUTH_DOMAIN,
    clientId: config.PARTNER_APIGEE_CLIENT_ID,
    redirectURI: redirectUri,
    scope: 'read write',
    idToken,
    partnerClientId: clientConsumerKey
  }

  redirectToAuth(authParams)
}

export default redirectToLwsIDP
